import FAQList from '../../../../settings/components/FAQ/FAQList';

const FAQPage = () => {
    return <FAQList />;
};

export default FAQPage;
